import React from 'react'
import { getHexColor, TwoColorIconProps } from '../utils'

export const TextCircleIcon: React.FC<TwoColorIconProps> = ({
  color1 = 'core-oxide',
  color2 = 'white',
  className,
  size = 16,
}) => {
  const c1 = getHexColor(color1)
  const c2 = getHexColor(color2)

  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width={size} height={size} rx={size / 2} fill={c2} />
      <path
        d="M4.25 11.1563V5.50002C4.25 5.27085 4.33167 5.0746 4.495 4.91127C4.65806 4.74821 4.85417 4.66669 5.08333 4.66669H10.9167C11.1458 4.66669 11.3421 4.74821 11.5054 4.91127C11.6685 5.0746 11.75 5.27085 11.75 5.50002V9.66669C11.75 9.89585 11.6685 10.0921 11.5054 10.2554C11.3421 10.4185 11.1458 10.5 10.9167 10.5H5.91667L4.95833 11.4584C4.82639 11.5903 4.67528 11.6197 4.505 11.5467C4.335 11.4739 4.25 11.3438 4.25 11.1563Z"
        fill={c1}
      />
    </svg>
  )
}
